import React, { useState, useEffect } from 'react';
import { ImageOff } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * <SmartImage /> — renders an image with graceful fallback.
 * Accepts same props as <img>. When `src` fails to load (404, CORS, etc.),
 * replaces with a clean placeholder instead of showing broken alt-text.
 * Also auto-prepends API_BASE to relative `/api/...` URLs.
 */
const SmartImage = ({ src, alt = '', fallbackLabel, className = '', ...rest }) => {
  const normalize = (u) => (u && u.startsWith('/api') ? `${API_BASE}${u}` : u);
  const [currentSrc, setCurrentSrc] = useState(normalize(src));
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setCurrentSrc(normalize(src));
    setErrored(false);
  }, [src]);

  if (!currentSrc || errored) {
    return (
      <div
        className={`flex flex-col items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 ${className}`}
        role="img"
        aria-label={alt}
        {...rest}
      >
        <ImageOff className="w-8 h-8 mb-1 opacity-60" />
        <span className="text-[10px] font-medium uppercase tracking-wide text-center px-2 line-clamp-2">
          {fallbackLabel || alt || 'Sin imagen'}
        </span>
      </div>
    );
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      onError={() => setErrored(true)}
      className={className}
      {...rest}
    />
  );
};

export default SmartImage;
